import { Injectable } from "@angular/core";
import { TreatmentProvider } from "./models/TreatmentProviders.models";

export interface FilterOptions {
  caseSensitive?: boolean;
  wholeWord?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FilterService {
  filterProvidersByKeywords(
    providers: TreatmentProvider[],
    selectedDemographics: string[],
    selectedServices: string[],
    selectedPayerSources: string[]
  ): TreatmentProvider[] {
    let filteredList = providers;

    if(selectedDemographics.length > 0) {
      filteredList = filterProvidersByDemographic(filteredList, selectedDemographics);
    }

    if(selectedServices.length > 0) {
      filteredList = filterByKeywords(filteredList, selectedServices);
    }

    if(selectedPayerSources.length > 0) {
      filteredList = filterByPayerSources(filteredList, selectedPayerSources);
    }

    return filteredList;
  }
}


const containsKeyword = function(
  description: string,
  keywords: string[],
  options: FilterOptions = {}
): boolean {
  const { wholeWord = false, caseSensitive = false } = options;

  // Escape special regex characters in keywords
  const escapedKeywords = keywords.map(keyword =>
    keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );

  const pattern = escapedKeywords.join('|');
  const wordBoundary = wholeWord ? '\\b' : '';
  const flags = caseSensitive ? '' : 'i';
  const regex = new RegExp(wordBoundary + '(' + pattern + ')' + wordBoundary, flags);
  return regex.test(description);
}

// const checkKeywords = function(
//   servicesOffered: string,
//   keywords: string[]
// ): boolean {
//   if(!keywords.length || !servicesOffered) return false;
//   const services = words(servicesOffered).map(toLower);
//
//   return intersection(services, keywords).length > 0;
// }

const filterByKeywords = function(
  providers: TreatmentProvider[],
  keywords: string[]
): TreatmentProvider[] {

  return providers.filter(provider => containsKeyword(provider.servicesOffered, keywords));
}

function filterProvidersByDemographic(
  providers: TreatmentProvider[],
  keywords: string[]
): TreatmentProvider[] {
  const filteredProviders: TreatmentProvider[] = [];

  for (let index = 0; index < providers.length; index++) {
    const provider = providers[index];

    if(provider.demographic) {
      if(containsKeyword(provider.demographic, keywords)) {
        filteredProviders.push(provider)
      }
    } else {
      if(containsKeyword(provider.servicesOffered, keywords)) {
        filteredProviders.push(provider)
      }
    }
  }

  return filteredProviders;
}

const filterByPayerSources = function(
  providers: TreatmentProvider[],
  keywords: string[]
): TreatmentProvider[] {

  return providers.filter(provider => containsKeyword(provider.payerSource, keywords));
}

